export default __webpack_public_path__ + "static/media/bike-friendly-accommodation.e4f8299f.svg";